import React from "react";
import { Chip } from "@mui/material";
import { ETicketPriority, ETicketPriorityColors } from "../../Utils/Enums";
import { Vocabulary } from "../../Utils/Vocabulary";

interface PriorityChipProps {
  priority: string;
  size?: "small" | "medium";
}

const PriorityChip: React.FC<PriorityChipProps> = ({ priority, size = "small" }) => {
  const getPriorityLabel = (priority: string): string => {
    switch (priority) {
      case ETicketPriority.LOW:
        return Vocabulary.priorityLow;
      case ETicketPriority.MEDIUM:
        return Vocabulary.priorityMedium;
      case ETicketPriority.HIGH:
        return Vocabulary.priorityHigh;
      case ETicketPriority.URGENT:
        return Vocabulary.priorityUrgent;
      default:
        return priority;
    }
  };

  const getPriorityColor = (priority: string): string => {
    switch (priority) {
      case ETicketPriority.LOW:
        return ETicketPriorityColors.LOW;
      case ETicketPriority.MEDIUM:
        return ETicketPriorityColors.MEDIUM;
      case ETicketPriority.HIGH:
        return ETicketPriorityColors.HIGH;
      case ETicketPriority.URGENT:
        return ETicketPriorityColors.URGENT;
      default:
        return "#666";
    }
  };

  return (
    <Chip
      label={getPriorityLabel(priority)}
      size={size}
      sx={{
        backgroundColor: getPriorityColor(priority),
        color: "#fff",
        fontWeight: "bold",
      }}
    />
  );
};

export default PriorityChip;
